import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { PageContent } from 'src/pages/page-content.js';
import 'src/utilities/display-alert';
import '../../content/d-entity-header.js';
import '../../library/components/d-help-section.js';
import '../../library/elements/d-action.js';
import type { PageViewModel } from '@trinnvis/dabih-api-client';
import type { EmployeesPageViewModel } from './employees-page-view-model';

/**
 *
 */
@customElement('d-employees-page-content')
export class DEmployeesPageContent extends PageContent<EmployeesPageViewModel> {
  @property({ type: Array })
  pages: PageViewModel[] = [];
  @property({ type: Boolean, attribute: 'write-access', reflect: true })
  writeAccess = false;
  @property({ type: Boolean })
  editMode = false;
  @property({ type: Object })
  token = {};
  @property({ type: Boolean })
  uncoverPageMenu = false;
  @property({ type: String })
  key = '';

  renderContent() {
    return html`<d-list-section
      no-header
      icon="employees"
      field="organization_employees"
      .items=${this.pageView.employees}
      theme-page
      .contentStickyTop=${this.contentStickyTop}
    >
    </d-list-section> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-employees-page-content': DEmployeesPageContent;
  }
}
